import React, { Component } from "react";
import { Table, Button, Col, Row, Tooltip } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";
import Colors from "../utils/Colors";

const { Column } = Table;

class CondicionalPrintModal extends Component {
    state = {
        registro: [],
        venc_idf: 0,
        ven_qtde_prod: 0,
        ven_vlr_total: 0,
        listaProdutos: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        // console.log('CondicionalPrintModal - componentDidUpdate - this.props: ', this.props);
        // console.log('CondicionalPrintModal - componentDidUpdate - propsAnte: ', propsAnte);

        // if (!stateAnte.visualizar && this.state.visualizar) {
        //     this.getListaRegistros();
        // }
        if ((this.props.visivel !== propsAnte.visivel) && (this.props.venc_idf)) {
            this.setState({
                venc_idf: this.props.venc_idf,
                registro: [],
                visualizar: true,
            });
            this.getListaRegistros();
        }

    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { venc_idf } = this.props;

        axios
            .get(`/condicional/show/${venc_idf}`)
            .then(response => {
                const { data } = response;

                // console.log('getListaRegistros: ', data);

                let ven_qtde_prod = 0;
                let ven_vlr_total = 0;
                for (var x in data.listaProdutos) {
                    ven_qtde_prod = ven_qtde_prod + parseFloat(data.listaProdutos[x].mi_qtde);
                    ven_vlr_total = ven_vlr_total + parseFloat(data.listaProdutos[x].mi_vlr_total);
                };

                this.setState({
                    registro: data.dados,
                    listaProdutos: data.listaProdutos,
                    ven_qtde_prod,
                    ven_vlr_total,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            venc_idf: 0,
            registro: [],
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (venc_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(venc_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }

    render() {
        const { onCancelarPrintClick, visivel } = this.props;
        const { carregando, visualizar, listaProdutos } = this.state;
        const { venc_numero, venc_dt_venda, venc_pessoa, pes_nome, usu_nome,
            venc_obs, pes_fone1, pes_fone2, pes_fone3,
            pes_endereco, pes_numero, pes_bairro, pes_cep, cmun_descricao, cuf_sigla } = this.state.registro;

        // console.log('registro: ', this.state.registro);

        return (
            <span style={{}}>
                {/* <Tooltip title="Imprimir">
                    <Button style={{ height: 25, width: 35, padding: 0 }} onClick={this.onVisualizar} icon="printer" />
                </Tooltip> */}
                <PrintModal
                    visible={visivel}
                    onCancel={onCancelarPrintClick}
                >
                    <div>
                        <div className="titulo">
                            Condicional
                        </div>

                        <div style={{ marginTop: 20, height: 2, backgroundColor: Colors.background }} />

                        <Row style={{ marginLeft: 20, marginTop: 10 }}>
                            <Col xs={6} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Número: </span>
                                <span> {venc_numero} </span>
                            </Col>
                            <Col xs={16} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Data: </span>
                                <span> {this.renderData(venc_dt_venda)} </span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Vendedor: </span>
                                <span> {usu_nome} </span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 10 }} >
                                <span style={{ fontWeight: 'bold', fontSize: 20 }}>Cliente: </span>
                                <span> {venc_pessoa + ' - ' + pes_nome} </span>
                            </Col>
                            {(pes_fone1 !== '' || pes_fone2 !== '' || pes_fone3 !== '') && (pes_fone1 !== '(  )      -' || pes_fone2 !== '(  )      -' || pes_fone3 !== '(  )      -') ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>Fones: </span>
                                    <span> {pes_fone1 !== '' && pes_fone1 !== '(  )      -' ? ' - ' + pes_fone1 : ''} </span>
                                    <span> {pes_fone2 !== '' && pes_fone2 !== '(  )      -' ? ' - ' + pes_fone2 : ''} </span>
                                    <span> {pes_fone3 !== '' && pes_fone3 !== '(  )      -' ? ' - ' + pes_fone3 : ''} </span>
                                </Col>
                            ) : null}
                            <Col xs={24} style={{ marginTop: 5, marginBottom: 10 }} >
                                <span style={{ fontWeight: 'bold' }}>Endereço: </span>
                                <span> {pes_endereco ? pes_endereco : ''} </span>
                                <span> {pes_numero ? ' - ' + pes_numero : ''} </span>
                                <span> {pes_bairro ? ' - ' + pes_bairro : ''} </span>
                                <span> {pes_cep ? ' - ' + pes_cep : ''} </span>
                                <span> {cmun_descricao ? ' - ' + cmun_descricao : ''} </span>
                                <span> {cuf_sigla ? ' - ' + cuf_sigla : ''} </span>
                            </Col>
                            {venc_obs ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>OBS: </span>
                                    <span> {venc_obs} </span>
                                </Col>
                            ) : null}
                        </Row>

                        <Row style={{ marginTop: 10 }}>
                            <Col xs={5} style={{ marginTop: 5 }} >
                                <span></span>
                            </Col>
                            <Col xs={9} style={{ marginTop: 5, textAlign: "end" }} >
                                <span style={{ fontSize: 16, fontWeight: 'bold' }}>Qtde Produtos: </span>
                                <span style={{ fontSize: 17 }}> {this.state.ven_qtde_prod} </span>
                            </Col>
                            <Col xs={10} style={{ marginTop: 5, textAlign: "end" }} >
                                <span style={{ fontSize: 16, fontWeight: 'bold' }}>Valor: </span>
                                <span style={{ fontSize: 17 }}> R$ {this.renderValor(this.state.ven_vlr_total)} </span>
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: 20 }}>
                            <div style={{ color: Colors.textDisabledDark, fontSize: 16, fontWeight: "bold", paddingLeft: 20, paddingTop: 3, marginTop: 10, marginBottom: 10, height: 30, backgroundColor: Colors.background }}>
                                LISTA DE PRODUTOS
                            </div>

                            <Row>
                                <Table
                                    pagination={false}
                                    dataSource={listaProdutos}
                                    rowKey={(listaRegistros => listaRegistros.mi_idf)}
                                    loading={{
                                        spinning: carregando,
                                        tip: 'Carregando. Aguarde...',
                                        size: "large"
                                    }}
                                >
                                    <Column
                                        key="prod_codigo"
                                        dataIndex="prod_codigo"
                                        title="Item"
                                        width={80}
                                        align="center"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="prod_descricao"
                                        dataIndex="prod_descricao"
                                        title="Descrição do Item"
                                        width={300}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="mi_qtde"
                                        dataIndex="mi_qtde"
                                        title="Qtde"
                                        render={this.renderValor}
                                        width={90}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="mi_vlr_unit"
                                        dataIndex="mi_vlr_unit"
                                        title="Vlr Unitário"
                                        render={this.renderValor}
                                        width={90}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="mi_vlr_desc"
                                        dataIndex="mi_vlr_desc"
                                        title="Desconto"
                                        render={this.renderValor}
                                        width={90}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="mi_vlr_total"
                                        dataIndex="mi_vlr_total"
                                        title="Valor Total"
                                        render={this.renderValor}
                                        width={90}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                </Table>
                            </Row>
                        </Row>

                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default CondicionalPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/CondicionalPrintModal.js